import React from "react";
import "../../components/mdmCardMenu/MdmCardMenu.css";
import Popper from "@mui/material/Popper";
import {  DomainValue } from "../../services/mdmService/types";
import { TranslationEnum, usePortalTranslation } from "../../providers/TranslationProvider";
import RenderSvg from "../../components/renderSvg/RenderSvg";
import { MENU_OPTIONS_MAP } from "../mdm/mdmRegistry";
type MdmCard={
  menuMoreOption: DomainValue|null
  id : string | undefined;
  open : boolean;
  popoverAnchorElement:HTMLElement | null
  mdmMenuRegistry : (event: React.MouseEvent<HTMLElement|null>)=> void
}
function NewMdmCardMenu(props: MdmCard) {
    const { translate } = usePortalTranslation();
  
    return (
      <Popper id="simple-popper" open={props.open} anchorEl={props.popoverAnchorElement}>
        <div className="mdm-card-menu-more-options">
          {props.menuMoreOption?.menuOption.map(({ id }) => {
            const option = MENU_OPTIONS_MAP[id];
            if (!option) return null; 
  
            return (
              <div
                className="mdm-card-menu-box"
                id={id}
                key={id}
                onClick={props.mdmMenuRegistry}
              >
                <div className="mdm-card-menu-icon-name">
                  <RenderSvg name={option.icon} />
                </div>
                <div className="mdm-card-menu-label">
                  {translate(TranslationEnum.common_portal, option.label)}
                </div>
              </div>
            );
          })}
        </div>
      </Popper>
    );
  }
  
export default NewMdmCardMenu;


   